import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useIsAuthenticated, useIsEmployeeLoaded} from '../../hooks';

/**
 * Sets document.title for the current page, replicating PageDocumentDetails' logic:
 * shows the default title while initial/employee data is loading, "{title} | {defaultTitle}"
 * once loaded.
 * @param {string} title
 */
export const useDocumentTitle = (title) => {
  const initialLoading = useSelector(state => state.main.initialLoading);
  const isAuthenticated = useIsAuthenticated();
  const isEmployeeLoaded = useIsEmployeeLoaded();
  const [t] = useTranslation('main');

  useEffect(() => {
    const defaultTitle = t('pageTitles.defaultTitle');
    const pageTitle = `${title} | ${defaultTitle}`;

    if (initialLoading) {
      document.title = defaultTitle;
    } else if (isAuthenticated) {
      document.title = isEmployeeLoaded ? pageTitle : defaultTitle;
    } else {
      document.title = pageTitle;
    }
  }, [title, initialLoading, isAuthenticated, isEmployeeLoaded, t]);
};
